var _rect, _circle, _circle2, _circle3, _polyline, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlgovexIcon48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "#0d1117"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 36,
    stroke: "#1e2a2a",
    strokeWidth: 1.5,
    fill: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 36,
    stroke: "#00d4aa",
    strokeWidth: 2,
    fill: "none",
    strokeDasharray: "56 170",
    strokeDashoffset: -24,
    opacity: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 36,
    stroke: "#00d4aa",
    strokeWidth: 2,
    fill: "none",
    strokeDasharray: "28 198",
    strokeDashoffset: -100,
    opacity: 0.3
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "18,48 28,48 33,32 40,62 47,38 54,54 60,42 68,42 74,48 78,48",
    stroke: "#00d4aa",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 3,
    fill: "#00d4aa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgovexIcon48);
export default __webpack_public_path__ + "static/media/algovex-icon-48.ebefd8bf7c7dec08243ac5339486a7f5.svg";
export { ForwardRef as ReactComponent };